import React from 'react';
import { Link } from 'react-router-dom';
import icons from '../../assets/icons';

const HelpfulLinks = ({ documentationEnabled = false }) => {
  const helpfulLinks = [
    {
      label: 'Support',
      url: 'mailto:support@admobilize.com',
      labelUrl: "support@admobilize.com",
      isExternal: false
    },
    ...(documentationEnabled
      ? [{ label: 'Documentation', labelUrl: 'Open documentation', to: '/documentation' }]
      : [])
  ];

  return (
    <div className="profile-cards helpful-links">
      <div className="card">
        <div className="card-header">
          <img src={icons.externalLinkDark} alt="user icon"/>
          <h3>Links</h3>
        </div>
        <div className="card-body">
          {
            helpfulLinks.map((link, i) => (
              <div className="link" key={i}>
                <h4>{link.label}</h4>
                {link.to ? (
                  <Link to={link.to}>{link.labelUrl}</Link>
                ) : (
                  <a
                    href={link.url}
                    target={link.isExternal ? '_blank' : '_self'}
                    rel="noreferrer">
                    {link.labelUrl || link.url}
                  </a>
                )}
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default HelpfulLinks;
